"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardItemChangesClient = void 0;
const sdk_contants_1 = require("../../constants/sdk.contants");
const serializers_1 = require("../serializers");
const retryable_1 = require("./retryable");
class StandardItemChangesClient {
    static newInstance(options, retryOptions) {
        const standardItemSerializer = new serializers_1.StandardItemSerializer();
        const standardItemChangesSerializer = new serializers_1.StandardItemChangesSerializer();
        return new StandardItemChangesClient(retryable_1.RetryableHttpClient.newInstance(options, retryOptions), standardItemSerializer, standardItemChangesSerializer);
    }
    constructor(client, standardItemSerializer, standardItemChangesSerializer) {
        this.client = client;
        this.standardItemSerializer = standardItemSerializer;
        this.standardItemChangesSerializer = standardItemChangesSerializer;
    }
    async findChangesById(id, status, headers) {
        const params = {
            id: id,
            status: status,
        };
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemChanges/findChangesById`, {
            headers,
            params,
        });
        return {
            standardItem: this.standardItemSerializer.serializeOne(response.body.data.standardItem),
            standardItemChanges: response.body.data.standardItemChanges.map((standardItemChanges) => this.standardItemChangesSerializer.serializeOne(standardItemChanges)),
        };
    }
    async findAllByGlobalId(globalIds, headers) {
        const params = {
            globalIds: globalIds,
        };
        const response = await this.client.get(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemChanges`, {
            headers,
            params,
        });
        return response.body.data.map((standardItemChanges) => this.standardItemChangesSerializer.serializeOneWithStandardSet(standardItemChanges));
    }
    async createOrUpdateChanges(standarItemChange, headers) {
        const response = await this.client.post(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemChanges/create`, standarItemChange, {
            headers,
        });
        return response.body.data.map((item) => this.standardItemChangesSerializer.serializeOne(item));
    }
    async apply(standardItemChange, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemChanges/apply`, standardItemChange, {
            headers,
        });
        return response.body.data.map((item) => this.standardItemChangesSerializer.serializeApplyOrReject(item));
    }
    async reject(standardItemChange, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemChanges/rejectAll`, standardItemChange, {
            headers,
        });
        return response.body.data.map((item) => this.standardItemChangesSerializer.serializeApplyOrReject(item));
    }
    async rejectOne(standardItemChange, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemChanges/reject`, standardItemChange, {
            headers,
        });
        return response.body.data;
    }
    async delete(standardItemChange, headers) {
        const response = await this.client.delete(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemChanges/delete`, {
            data: standardItemChange,
            headers,
        });
        return response.body.data;
    }
    async updateStandardItemChangeStatus(standardItemChangesUpdateStatusDto, headers) {
        const response = await this.client.put(`${sdk_contants_1.ENGINE_API_PREFIX}/standardItemChanges/bulk/status`, standardItemChangesUpdateStatusDto, {
            headers,
        });
        return this.standardItemChangesSerializer.serializeRowsAffected(response.body.data);
    }
}
exports.StandardItemChangesClient = StandardItemChangesClient;
//# sourceMappingURL=standard-item-changes.client.js.map